import {Actions, createEffect, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {catchError, EMPTY, switchMap, tap} from 'rxjs';
import {Injectable} from '@angular/core';
import {OfficerRequiredDocumentService} from "@modules/officer/services/officer-required-document.service";
import {OfficerRequiredDocumentApi} from "@modules/officer/api/officer-required-document.api";

@Injectable()
export class OfficerRequiredDocumentInitializerEffects {
  initOfficerRequiredDocuments$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.officerRequiredDocumentApi.get$()),
      tap(officerRequiredDocuments => this.officerRequiredDocumentService.dispatchSetEntities(officerRequiredDocuments)),
      catchError(e => {
        console.error(e);

        this.officerRequiredDocumentService.dispatchClearEntitiesAction()

        return EMPTY;
      }),
    )
  }, {dispatch: false});

  constructor(
    private actions$: Actions,
    private officerRequiredDocumentApi: OfficerRequiredDocumentApi,
    protected readonly officerRequiredDocumentService: OfficerRequiredDocumentService
  ) {
  }
}
